"use client";

import React, { type ReactElement } from "react";
import {
  Header,
  PortalNav,
  PortalHeaderFeedback,
  PortalHeaderUserMenu,
} from "@oreme/ui";
import { Observatory, User, Tag } from "@/types";
import { useTranslations } from "next-intl";
import { HeaderSearch } from "@/components";

interface GlobalHeaderProps {
  observatories: Observatory[];
  tags: Tag[];
  user: User | null;
}

function GlobalHeader({
  observatories,
  tags,
  user,
}: Readonly<GlobalHeaderProps>): ReactElement {
  const t = useTranslations("global.Branding");
  const url = "https://data.oreme.org/";

  return (
    <Header title={t("title")} href={url} className="font-inter">
      <div className="fixed inset-x-0">
        <PortalNav />
      </div>
      <ul className="relative z-10 flex flex-row list-none gap-2 items-center h-8">
        {observatories.length && tags.length ? (
          <li>
            <HeaderSearch observatories={observatories} tags={tags} />
          </li>
        ) : null}
        <li>
          <PortalHeaderFeedback />
        </li>
        <li>
          <PortalHeaderUserMenu />
        </li>
        <li className="md:hidden">
          <PortalNav isMobile />
        </li>
      </ul>
    </Header>
  );
}

export { GlobalHeader, type GlobalHeaderProps };
